





































































import Vue from 'vue'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

import Modal from '../general/modal/Modal.vue'
import ModalBody from '../general/modal/ModalBody.vue'
import DatePicker from '../DatePicker.vue'
import QuillEditor from '../controls/QuillEditor.vue'
import { CIcon } from '@coreui/icons-vue'
import { cilX } from '@coreui/icons-pro'
import '../../styles/add-event-modal.css'

export default Vue.extend({
  mixins: [validationMixin],
  validations: {
    name: { required },
    description: { required },
    selectedCategory: {
      selected: (value) => value !== -1,
    },
    eventTypeId: {
      selected: (value) => value !== -1,
    },
  },
  data() {
    return {
      name: '',
      description: '',
      date: new Date().toISOString().substring(0, 10),
      endDate: new Date().toISOString().substring(0, 10),

      categories: [],
      selectedCategory: -1,
      types: [],
      eventTypeId: -1,

      exitIcon: cilX,

      saving: false,
      loading: false,
    }
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    editEvent: {
      type: Object,
      required: false,
    },
  },
  mounted: async function () {
    this.categories = await (await fetch('/api/Calendar/Categories')).json()
  },
  watch: {
    editEvent: {
      immediate: true,
      handler: async function (val) {
        if (this.type === 'edit') {
          this.name = val.name
          this.description = val.details
          this.selectedCategory = val.categoryId
          this.date = val.start
          this.endDate = val.end
          await this.populateTypes()
          this.eventTypeId = val.typeId
        }
      },
    },
  },
  methods: {
    populateTypes: async function () {
      this.loading = true
      this.types = await (
        await fetch(`/api/Calendar/Categories/${this.selectedCategory}/Types`)
      ).json()
      this.loading = false
    },
    close: function () {
      this.name = ''
      this.description = ''
      this.eventTypeId = -1
      this.selectedCategory = -1
      this.date = new Date().toISOString().substr(0, 10)
      this.$v.$reset()
      this.$emit('close')
    },
    add: async function () {
      if (
        this.$v.name.$invalid ||
        this.$v.selectedCategory.$invalid ||
        this.$v.eventTypeId.$invalid ||
        this.$v.description.$invalid
      ) {
        this.$v.$touch()
        return
      }

      this.saving = true

      await fetch('/api/Calendar', {
        method: this.type === 'edit' ? 'PUT' : 'POST',
        body: JSON.stringify({
          id: this.type === 'edit' ? this.editEvent.id : 0,
          name: this.name,
          description: this.description,
          date: this.date,
          endDate: this.endDate,
          eventTypeId: this.eventTypeId,
        }),
      })
      this.close()
      this.$emit('refresh')
      this.saving = false
    },
  },
  computed: {
    nameErrors() {
      const vueInstance = this as any

      const errors: any[] = []
      if (!vueInstance.$v.name.$dirty) return errors
      !vueInstance.$v.name.required && errors.push('Name is required')
      return errors
    },
    categoryErrors() {
      const vueInstance = this as any

      const errors: any[] = []
      if (!vueInstance.$v.selectedCategory.$dirty) return errors
      !vueInstance.$v.selectedCategory.selected &&
        errors.push('Category is required')
      return errors
    },
    typeErrors() {
      const vueInstance = this as any

      const errors: any[] = []
      if (!vueInstance.$v.eventTypeId.$dirty) return errors
      !vueInstance.$v.eventTypeId.selected && errors.push('Type is required')
      return errors
    },
    descriptionErrors() {
      const vueInstance = this as any

      const errors: any[] = []
      if (!vueInstance.$v.description.$dirty) return errors
      !vueInstance.$v.description.maxLength &&
        errors.push(
          `Description length can't exceed ${vueInstance.$v.description.$params.maxLength.max} characters`
        )
      return errors
    },
  },
  components: { CIcon, Modal, ModalBody, DatePicker, QuillEditor },
  name: 'AddEventModal',
})
